/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AnyAction, Reducer, combineReducers as cr } from 'redux';
interface ReducerType<S> {
  [key: string]: (state: S, action: AnyAction) => S;
}

export function createReducer<S>(initialState: S, reducer: ReducerType<S>) {
  return (state = initialState, action: AnyAction) =>
    action.type in reducer ? reducer[action.type](state, action) : state;
}

type ReducerMapObjectType = Reducer<any> | Record<string, unknown> | any | any[] | string | null;
export type ReducerOptionalMapObject = ReducerMapObjectType | undefined;

export function combineReducers<
  TState,
  TReducerMapObject = Record<keyof TState, ReducerOptionalMapObject>
>(reducers: { [key: string]: TReducerMapObject }): Reducer<TState> {
  return cr<TState>(
    Object.keys(reducers).reduce<any>((acc, key) => {
      acc[key] =
        typeof reducers[key] === 'function'
          ? reducers[key]
          : (state: unknown = reducers[key]) => state;
      return acc;
    }, {})
  );
}
